/**
 * EroticShop — Kategori Sayfası v2.0
 * collection-page.js
 * ────────────────────────────────────────────────────────────
 * v1.0 → v2.0 değişiklikler:
 * - AJAX pill navigasyonu (Section Rendering API + pushState)
 *   → sayfa tam yenilenmez, sadece .coll-layout + chips swap
 * - MobileSheet event delegation → accumulate bug yok
 * - LoadMore + FilterAccordion reinit-safe (eski handler temizlenir)
 * - ESColl.reinit() public API (Quick View vb. dış modüller için)
 * - Stock clear tracking: data-clears-stock attr + sessionStorage
 * - Pills: "Tümü" her zaman tıklanabilir (visibility hack kaldırıldı)
 *
 * Modüller:
 *  1. FilterAccordion  — sidebar/sheet filtre grup toggle
 *  2. PriceSlider      — logaritmik dual-handle (₺500–₺200,000)
 *  3. MobileSheet      — mobil filtre bottom drawer (delegation)
 *  4. SortSelect       — sort_by URL güncelleme
 *  5. LoadMore         — AJAX + Section Rendering API + pushState
 *  6. PillsState       — aktif pill tespiti + scroll konumu
 *  7. PillsAjax        — AJAX koleksiyon navigasyonu (delegation)
 *  8. StockClear       — filtre temizleme sessionStorage tracking
 *  9. Init + Public API
 * ────────────────────────────────────────────────────────────
 */

(function (w, d) {
  'use strict';

  /* ──────────────────────────────────────────────────────
     YARDIMCI
  ────────────────────────────────────────────────────── */
  function qs(sel, ctx)  { return (ctx || d).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }

  /* ──────────────────────────────────────────────────────
     1. FILTER ACCORDION
     reinit-safe: _esAccordionHandler aynı element'e 1x bağlanır
  ────────────────────────────────────────────────────── */
  function initFilterAccordion(ctx) {
    qsa('.coll-filter-group', ctx).forEach(function (group) {
      var toggle = qs('.coll-filter-toggle', group);
      if (!toggle) return;

      var isOpen = group.classList.contains('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (toggle._esAccordionHandler) {
        toggle.removeEventListener('click', toggle._esAccordionHandler);
      }
      toggle._esAccordionHandler = function () {
        var open = group.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      toggle.addEventListener('click', toggle._esAccordionHandler);
    });
  }

  /* ──────────────────────────────────────────────────────
     2. LOGARİTMİK PRICE SLIDER
     φ skala: pos = log(val/min) / log(max/min) * 100
  ────────────────────────────────────────────────────── */
  function initPriceSlider(ctx) {
    qsa('.coll-price-slider-wrap', ctx || d).forEach(function (wrap) {
      if (wrap._esSliderInited) return;

      var rangeMin = qs('.coll-price-range-input[data-role="min"]', wrap);
      var rangeMax = qs('.coll-price-range-input[data-role="max"]', wrap);
      var fill     = qs('.coll-price-fill',                          wrap);
      var inputMin = qs('.coll-price-input[data-role="min"]',        wrap);
      var inputMax = qs('.coll-price-input[data-role="max"]',        wrap);
      if (!rangeMin || !rangeMax || !fill) return;
      wrap._esSliderInited = true;

      var PRICE_MIN = parseInt(wrap.dataset.priceMin  || '0',      10);
      var PRICE_MAX = parseInt(wrap.dataset.priceMax  || '200000', 10);

      // Linear skala — min=0'a izin verir, max koleksiyon-bazlı (filter.range_max)
      function toPos(val) {
        if (PRICE_MAX <= PRICE_MIN || val <= PRICE_MIN) return 0;
        if (val >= PRICE_MAX) return 100;
        return ((val - PRICE_MIN) / (PRICE_MAX - PRICE_MIN)) * 100;
      }
      function toVal(pos) {
        return Math.round(PRICE_MIN + (pos / 100) * (PRICE_MAX - PRICE_MIN));
      }
      function updateFill() {
        var lo = parseFloat(rangeMin.value);
        var hi = parseFloat(rangeMax.value);
        fill.style.left  = lo + '%';
        fill.style.width = (hi - lo) + '%';
      }
      function syncInputs() {
        if (inputMin) inputMin.value = toVal(parseFloat(rangeMin.value));
        if (inputMax) inputMax.value = toVal(parseFloat(rangeMax.value));
        updateFill();
      }

      var params = new URLSearchParams(w.location.search);
      rangeMin.value = toPos(parseInt(params.get('filter.v.price.gte') || PRICE_MIN, 10));
      rangeMax.value = toPos(parseInt(params.get('filter.v.price.lte') || PRICE_MAX, 10));
      syncInputs();

      rangeMin.addEventListener('input', function () {
        if (parseFloat(rangeMin.value) > parseFloat(rangeMax.value) - 2) {
          rangeMin.value = parseFloat(rangeMax.value) - 2;
        }
        syncInputs();
      });
      rangeMax.addEventListener('input', function () {
        if (parseFloat(rangeMax.value) < parseFloat(rangeMin.value) + 2) {
          rangeMax.value = parseFloat(rangeMin.value) + 2;
        }
        syncInputs();
      });

      function applyPrice() {
        var url = new URL(w.location.href);
        url.searchParams.set('filter.v.price.gte', toVal(parseFloat(rangeMin.value)));
        url.searchParams.set('filter.v.price.lte', toVal(parseFloat(rangeMax.value)));
        url.searchParams.delete('page');
        // Hard reload yerine AJAX swap → flicker yok (masaüstü + mobil ortak)
        if (typeof navigateToCollection === 'function') {
          navigateToCollection(url.href, null);
        } else {
          w.location.href = url.href;
        }
      }

      function handleText(input, isMin) {
        var raw     = String(input.value).replace(/\D/g, '');
        var val     = parseInt(raw, 10) || (isMin ? PRICE_MIN : PRICE_MAX);
        var clamped = Math.max(PRICE_MIN, Math.min(PRICE_MAX, val));
        input.value = clamped;
        if (isMin) rangeMin.value = toPos(clamped);
        else       rangeMax.value = toPos(clamped);
        updateFill();
      }

      if (inputMin) {
        inputMin.addEventListener('change', function () { handleText(inputMin, true); });
        inputMin.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { handleText(inputMin, true); applyPrice(); }
        });
      }
      if (inputMax) {
        inputMax.addEventListener('change', function () { handleText(inputMax, false); });
        inputMax.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { handleText(inputMax, false); applyPrice(); }
        });
      }

      // Apply butonu: bu wrap'in kapsayıcısındaki (sidebar veya sheet) "Uygula"
      var scope    = wrap.closest('.coll-sidebar, .coll-sheet') || (ctx || d);
      var applyBtn = qs('.coll-filter-apply', scope);
      if (applyBtn && !applyBtn._esPriceHandler) {
        applyBtn._esPriceHandler = applyPrice;
        applyBtn.addEventListener('click', applyBtn._esPriceHandler);
      }

      // Track'e tık/dokunuş → en yakın tutmacı oraya taşı (büyük-site davranışı)
      var trackWrap = qs('.coll-price-track-wrap', wrap);
      if (trackWrap) {
        trackWrap.addEventListener('pointerdown', function (e) {
          if (e.target === rangeMin || e.target === rangeMax) return; // thumb'a basıldıysa native drag
          var rect = trackWrap.getBoundingClientRect();
          if (!rect.width) return;
          var pos  = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
          var dMin = Math.abs(pos - parseFloat(rangeMin.value));
          var dMax = Math.abs(pos - parseFloat(rangeMax.value));
          if (dMin <= dMax) rangeMin.value = Math.min(pos, parseFloat(rangeMax.value) - 2);
          else              rangeMax.value = Math.max(pos, parseFloat(rangeMin.value) + 2);
          syncInputs();
          applyPrice();
        });
      }

      [rangeMin, rangeMax].forEach(function (r) {
        r.addEventListener('mouseup',  applyPrice);
        r.addEventListener('touchend', applyPrice, { passive: true });
      });
    });
  }

  /* ──────────────────────────────────────────────────────
     3. MOBİL BOTTOM SHEET
     Event delegation — document seviyesinde, tek seferlik bağlanır.
     DOM swap sonrası yeniden çağrılmaz → accumulate yok.
  ────────────────────────────────────────────────────── */
  var _sheetListenerAdded = false;

  function openSheet() {
    var sheet   = d.getElementById('coll-filter-sheet');
    var overlay = d.getElementById('coll-sheet-overlay');
    var closeBtn= d.getElementById('coll-sheet-close');
    if (!sheet) return;
    sheet.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    d.body.style.cssText += ';overflow:hidden;position:fixed;width:100%';
    sheet.setAttribute('aria-hidden', 'false');
    if (closeBtn) closeBtn.focus();
  }

  function closeSheet() {
    var sheet    = d.getElementById('coll-filter-sheet');
    var overlay  = d.getElementById('coll-sheet-overlay');
    var filterBtn= d.getElementById('coll-mobile-filter-btn');
    if (!sheet) return;
    sheet.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    d.body.style.overflow = '';
    d.body.style.position = '';
    d.body.style.width    = '';
    sheet.setAttribute('aria-hidden', 'true');
    if (filterBtn) filterBtn.focus();
  }

  function initMobileSheet() {
    if (_sheetListenerAdded) return;
    _sheetListenerAdded = true;

    d.addEventListener('click', function (e) {
      if (e.target.closest('#coll-mobile-filter-btn')) { openSheet(); return; }
      if (e.target.closest('#coll-sheet-overlay'))     { closeSheet(); return; }
      if (e.target.closest('#coll-sheet-close'))       { closeSheet(); return; }
      if (e.target.closest('#coll-sheet-apply'))       { closeSheet(); return; }
    });

    d.addEventListener('keydown', function (e) {
      var sheet = d.getElementById('coll-filter-sheet');
      if (e.key === 'Escape' && sheet && sheet.classList.contains('is-open')) closeSheet();
    });
  }

  function updateMobileFilterBadge() {
    var btn = d.getElementById('coll-mobile-filter-btn');
    if (!btn) return;
    var count = 0;
    new URLSearchParams(w.location.search).forEach(function (_, k) {
      if (k.startsWith('filter.')) count++;
    });
    var badge = btn.querySelector('.coll-mobile-filter-btn__count');
    if (badge) {
      badge.textContent   = count;
      badge.style.display = count > 0 ? 'inline-flex' : 'none';
    }
  }

  /* ──────────────────────────────────────────────────────
     4. SORT SELECT
  ────────────────────────────────────────────────────── */
  function initSortSelect(ctx) {
    var sel = qs('#coll-sort-select', ctx || d);
    if (!sel) return;
    if (sel._esSortHandler) sel.removeEventListener('change', sel._esSortHandler);
    sel._esSortHandler = function () {
      var url = new URL(w.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      w.location.href = url.href;
    };
    sel.addEventListener('change', sel._esSortHandler);
  }

  /* ──────────────────────────────────────────────────────
     5. LOAD MORE (AJAX + Section Rendering API + pushState)
  ────────────────────────────────────────────────────── */
  function initLoadMore(ctx) {
    var btn  = qs('#coll-load-more-btn', ctx || d);
    var grid = qs('#coll-product-grid',  ctx || d);
    if (!btn || !grid) return;

    if (btn._esLoadMoreHandler) btn.removeEventListener('click', btn._esLoadMoreHandler);

    var isLoading = false;

    btn._esLoadMoreHandler = function () {
      if (isLoading) return;
      var nextUrl = btn.dataset.nextUrl;
      if (!nextUrl) return;

      isLoading    = true;
      btn.disabled = true;
      var origText = btn.textContent;
      btn.textContent = 'Yükleniyor…';

      var sep      = nextUrl.includes('?') ? '&' : '?';
      var fetchUrl = nextUrl + sep + 'sections=main-collection-product-grid';

      fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var html   = data['main-collection-product-grid'];
          var parser = new DOMParser();
          var doc    = parser.parseFromString(html, 'text/html');

          qsa('.coll-product-item', doc).forEach(function (item) {
            grid.appendChild(item.cloneNode(true));
          });

          var newBtn = qs('#coll-load-more-btn', doc);
          if (newBtn && newBtn.dataset.nextUrl) {
            btn.dataset.nextUrl = newBtn.dataset.nextUrl;
            btn.textContent     = origText;
          } else {
            btn.style.display = 'none';
          }

          var pageUrl = new URL(nextUrl, w.location.origin);
          history.pushState(
            { esPage: pageUrl.searchParams.get('page') || '2' },
            '',
            pageUrl.pathname + pageUrl.search
          );

          if (w.EroticWishlist && typeof w.EroticWishlist.sync === 'function') {
            w.EroticWishlist.sync();
          }
        })
        .catch(function (err) {
          console.error('[LoadMore] Hata:', err.message);
          btn.textContent = 'Hata oluştu — tekrar dene';
          btn.style.color = '#e63946';
        })
        .finally(function () {
          isLoading    = false;
          btn.disabled = false;
        });
    };

    btn.addEventListener('click', btn._esLoadMoreHandler);
  }

  /* ──────────────────────────────────────────────────────
     6. PILLS STATE
     Aktif pill tespiti + bar scroll konumunu hizala.
     reinitModules() çağrıldığında URL'e göre yeniden hesaplar.
  ────────────────────────────────────────────────────── */
  var STOCK_PARAM = 'filter.v.availability';

  /* Stok chip'i kategori değil, URL-türevli bir toggle.
     State tek kaynaktan (location.search) hesaplanır → AJAX swap sonrası
     stale kalması imkânsız (pills bar swap edilmiyor). */
  function syncStockPill(bar) {
    var stockPill = qs('.coll-pill--stock', bar);
    if (!stockPill) return;

    /* getAll() — ?...=1&...=0 durumunda get() ilk değeri döner ve pill'i
       yanlışlıkla aktif gösterir. Filtre ancak TEK değer ve o da '1' ise aktiftir;
       her iki değer seçiliyse sonuç "tümü" demektir → pill pasif. */
    var stockVals = new URLSearchParams(w.location.search).getAll(STOCK_PARAM);
    var isOn      = stockVals.length === 1 && stockVals[0] === '1';

    stockPill.classList.toggle('coll-pill--active', isOn);
    stockPill.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    stockPill.setAttribute('title', isOn ? 'Stok filtresini kaldır' : 'Yalnızca stoktakileri göster');

    /* href = mevcut URL'in tersi (toggle) — diğer filtreler korunur */
    try {
      var url = new URL(w.location.href);
      url.searchParams.delete(STOCK_PARAM); // varsa her iki değeri de temizle
      if (!isOn) {
        url.searchParams.append(STOCK_PARAM, '1');
      }
      url.searchParams.delete('page'); // filtre değişince sayfa 1'e dön
      stockPill.setAttribute('href', url.pathname + url.search);
    } catch (_) { /* URL kurulamadıysa server-side href'e dokunma */ }
  }

  function initPillsState() {
    var bar = qs('.coll-pills-bar');
    if (!bar) return;

    /* Kategori pill'leri — stok chip'i hariç */
    var pills       = qsa('.coll-pill', bar).filter(function (p) {
      return !p.classList.contains('coll-pill--stock');
    });
    var allPill     = pills[0] || null;
    var currentPath = w.location.pathname;

    /* Aktif alt kategori pill'ini bul (path karşılaştırması) */
    var activePill = null;
    pills.forEach(function (pill, i) {
      if (i === 0) return;
      try {
        var pillPath = new URL(pill.href, w.location.origin).pathname;
        if (pillPath === currentPath) activePill = pill;
      } catch (_) { /* geçersiz href */ }
    });

    /* Sınıf güncelle — yalnız kategori pill'leri */
    pills.forEach(function (p) { p.classList.remove('coll-pill--active'); });
    if (activePill) {
      activePill.classList.add('coll-pill--active');
    } else if (allPill) {
      allPill.classList.add('coll-pill--active');
    }

    /* Stok chip'i ayrı yönetilir */
    syncStockPill(bar);

    /* Aktif pill'i bar ortasına getir */
    var target = activePill || allPill;
    if (target) {
      requestAnimationFrame(function () {
        var barW  = bar.clientWidth;
        var pillL = target.offsetLeft;
        var pillW = target.offsetWidth;
        bar.scrollLeft = Math.max(0, pillL - (barW - pillW) / 2);
      });
    }
  }

  /* ──────────────────────────────────────────────────────
     7. PILLS AJAX NAVİGASYON
     Event delegation — tek seferlik, .coll-pills-bar üzerinde.
     Tıklanan pill'in href'i Section Rendering API ile çekilir;
     sadece .coll-layout ve #coll-active-chips DOM'da swap edilir.
  ────────────────────────────────────────────────────── */
  var _pillsListenerAdded = false;

  function initPillsAjax() {
    var bar = qs('.coll-pills-bar');
    if (!bar || _pillsListenerAdded) return;
    _pillsListenerAdded = true;

    bar.addEventListener('click', function (e) {
      var pill = e.target.closest('.coll-pill');
      if (!pill || !pill.href) return;

      /* Stok chip'i toggle — aktifken tıklamak "filtreyi kaldır" demek,
         bu yüzden active-guard yalnızca kategori pill'leri için geçerli. */
      var isStockPill = pill.classList.contains('coll-pill--stock');

      /* Zaten aktifse navigasyon yapma, sadece scroll güncelle */
      if (!isStockPill && pill.classList.contains('coll-pill--active')) {
        e.preventDefault();
        requestAnimationFrame(function () {
          var barW  = bar.clientWidth;
          var pillL = pill.offsetLeft;
          var pillW = pill.offsetWidth;
          bar.scrollLeft = Math.max(0, pillL - (barW - pillW) / 2);
        });
        return;
      }

      e.preventDefault();

      /* Scroll önce (kullanıcı hareketi hissedilmeli) */
      requestAnimationFrame(function () {
        var barW  = bar.clientWidth;
        var pillL = pill.offsetLeft;
        var pillW = pill.offsetWidth;
        bar.scrollLeft = Math.max(0, pillL - (barW - pillW) / 2);
      });

      navigateToCollection(pill.href, pill);

    }, { passive: false });
  }

  /* ──────────────────────────────────────────────────────
     FİLTRE LİNKLERİ → AJAX (marka/renk/stok/chip/temizle)
     Pills hariç (onu initPillsAjax yönetir). Document delegation,
     tek sefer bağlanır → swap'tan sonra da çalışır.
  ────────────────────────────────────────────────────── */
  var _filterAjaxAdded = false;
  function initFilterAjax() {
    if (_filterAjaxAdded) return;
    _filterAjaxAdded = true;

    d.addEventListener('click', function (e) {
      var link = e.target.closest(
        '.coll-filter-item, .coll-color-swatch, .coll-active-chip, ' +
        '.coll-active-chip--clear, .coll-sidebar__clear, .coll-filter-reset'
      );
      if (!link || !link.href) return;
      if (link.closest('.coll-pills-bar')) return; // pills initPillsAjax'ta

      e.preventDefault();
      navigateToCollection(link.href, null);
    }, { passive: false });
  }

  /* ──────────────────────────────────────────────────────
     AJAX KOLEKSİYON NAVİGASYON
     Section Rendering API → .coll-layout + #coll-active-chips swap
  ────────────────────────────────────────────────────── */
  var _navInProgress = false;

  /* ── Panel UI state koru: açık akordeonlar + scroll (sidebar & sheet) ── */
  function esSnapshotPanelState() {
    function grab(scope) {
      if (!scope) return null;
      return {
        open: Array.prototype.map.call(scope.querySelectorAll('.coll-filter-group'), function (g) {
          return g.classList.contains('is-open');
        }),
        scroll: scope.scrollTop
      };
    }
    var sheet = d.getElementById('coll-filter-sheet');
    return {
      sidebar:   grab(qs('.coll-sidebar')),
      sheet:     grab(sheet),
      sheetOpen: !!(sheet && sheet.classList.contains('is-open'))
    };
  }
  function esRestorePanelState(snap) {
    if (!snap) return;
    function apply(scope, st) {
      if (!scope || !st) return;
      var groups = scope.querySelectorAll('.coll-filter-group');
      Array.prototype.forEach.call(groups, function (g, i) {
        if (typeof st.open[i] !== 'boolean') return;
        g.classList.toggle('is-open', st.open[i]);
        var t = qs('.coll-filter-toggle', g);
        if (t) t.setAttribute('aria-expanded', st.open[i] ? 'true' : 'false');
      });
      if (st.scroll) scope.scrollTop = st.scroll;
    }
    apply(qs('.coll-sidebar'), snap.sidebar);
    apply(d.getElementById('coll-filter-sheet'), snap.sheet);
  }

  function navigateToCollection(targetUrl, clickedPill) {
    if (_navInProgress) return;
    _navInProgress = true;

    var _panelSnap = esSnapshotPanelState();

    /* Optimistic UI — yalnız kategori pill'leri.
       Stok chip'ine dokunulmaz: tıklanan stok chip'i ise kategori active'i
       silinmemeli; her iki durumda da doğru state'i swap sonrası
       initPillsState() → syncStockPill() kurar. */
    var bar = qs('.coll-pills-bar');
    if (bar && clickedPill && !clickedPill.classList.contains('coll-pill--stock')) {
      qsa('.coll-pill', bar).forEach(function (p) {
        if (p.classList.contains('coll-pill--stock')) return;
        p.classList.remove('coll-pill--active');
      });
      clickedPill.classList.add('coll-pill--active');
    }

    /* Loading göstergesi */
    var mainEl = d.getElementById('coll-main');
    if (mainEl) {
      mainEl.style.transition = 'opacity 150ms ease';
      mainEl.style.opacity    = '0.45';
    }

    var sep      = targetUrl.includes('?') ? '&' : '?';
    var fetchUrl = targetUrl + sep + 'sections=main-collection-product-grid';

    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var html   = data['main-collection-product-grid'];
        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');

        /* ── .coll-layout swap ── */
        var newLayout = qs('.coll-layout', doc);
        var oldLayout = qs('.coll-layout');
        if (newLayout && oldLayout) {
          oldLayout.replaceWith(newLayout);
        }

        /* ── #coll-active-chips swap ── */
        var newChips = doc.getElementById('coll-active-chips');
        var oldChips = d.getElementById('coll-active-chips');
        if (newChips && oldChips) {
          oldChips.replaceWith(newChips);
        } else if (newChips && !oldChips) {
          var layout = qs('.coll-layout');
          if (layout) layout.insertAdjacentElement('beforebegin', newChips);
        } else if (!newChips && oldChips) {
          oldChips.remove();
        }

      /* ── .coll-breadcrumb swap ── */
var newBreadcrumb = qs('nav.coll-breadcrumb', doc);
var oldBreadcrumb = qs('nav.coll-breadcrumb');
if (newBreadcrumb && oldBreadcrumb) {
  oldBreadcrumb.replaceWith(newBreadcrumb);
} else if (newBreadcrumb && !oldBreadcrumb) {
  var collPage = qs('.coll-page');
  if (collPage) collPage.insertAdjacentElement('afterbegin', newBreadcrumb);
}

        /* ── Mobil sheet swap: facet sayımları canlı güncellensin (Issue 1) ── */
        var newSheet = doc.getElementById('coll-filter-sheet');
        var oldSheet = d.getElementById('coll-filter-sheet');
        if (newSheet && oldSheet) {
          oldSheet.replaceWith(newSheet);
          if (_panelSnap.sheetOpen) {           // açıktıysa açık kalsın (Issue 4)
            newSheet.classList.add('is-open');
            newSheet.setAttribute('aria-hidden', 'false');
            var ov = d.getElementById('coll-sheet-overlay');
            if (ov) ov.classList.add('is-visible');
          }
        }

        /* ── SEO metin bloğu swap — koleksiyona özel içerik (metafield) ──
           Pills ile koleksiyon değiştiğinde blok stale kalıyordu: URL yeni
           koleksiyonu gösterirken metin/aside önceki koleksiyona aitti. */
        var newSeo = qs('details.coll-seo-block', doc);
        var oldSeo = qs('details.coll-seo-block');
        if (newSeo && oldSeo) {
          /* Kullanıcı bloğu açtıysa yeni koleksiyonda da açık gelsin */
          if (oldSeo.hasAttribute('open')) newSeo.setAttribute('open', '');
          oldSeo.replaceWith(newSeo);
        } else if (newSeo && !oldSeo) {
          /* Önceki koleksiyonda seo_body yoktu → bloğu layout'un ardına ekle */
          var anchorLayout = qs('.coll-layout');
          if (anchorLayout) {
            anchorLayout.insertAdjacentElement('afterend', newSeo);
          } else {
            var collPageEl = qs('.coll-page');
            if (collPageEl) collPageEl.appendChild(newSeo);
          }
        } else if (!newSeo && oldSeo) {
          /* Yeni koleksiyonda seo_body yok → eski bloğu kaldır */
          oldSeo.remove();
        }

        /* URL güncelle */
        history.pushState({ esCollUrl: targetUrl }, d.title, targetUrl);

        /* Modülleri yeniden bağla */
        reinitModules();

        /* Akordeon açık-state + scroll geri yükle (sidebar & sheet) */
        esRestorePanelState(_panelSnap);
      })
      .catch(function (err) {
        console.error('[PillsAjax] Hata, hard navigate:', err.message);
        w.location.href = targetUrl;
      })
      .finally(function () {
        _navInProgress = false;
        if (mainEl) {
          mainEl.style.opacity    = '';
          mainEl.style.transition = '';
        }
      });
  }

  /* Geri/ileri tuşu — hard reload (Shopify paginate tutarlılığı) */
  w.addEventListener('popstate', function (e) {
    if (e.state && (e.state.esCollUrl || e.state.esPage)) {
      w.location.reload();
    }
  });

  /* ──────────────────────────────────────────────────────
     8. STOCK CLEAR TRACKING
     Kullanıcı filtreleri temizleyince sessionStorage'a yaz;
     bir sonraki yüklemede otomatik stok redirect çalışmasın.
  ────────────────────────────────────────────────────── */
  function initStockClearTracking() {
    d.addEventListener('click', function (e) {
      if (e.target.closest(
        '.coll-active-chip--clear, .coll-filter-reset, .coll-sidebar__clear, [data-clears-stock]'
      )) {
        try { sessionStorage.setItem('es_stok_cleared', '1'); } catch (_) {}
      }
    }, { passive: true });
  }

  /* ──────────────────────────────────────────────────────
     MODULE REINIT
     DOM swap (AJAX navigasyon) sonrası çağrılır.
     Delegation tabanlı modüller (MobileSheet, PillsAjax)
     yeniden bağlanmaz — onlar zaten document/bar seviyesinde.
  ────────────────────────────────────────────────────── */
  function reinitModules() {
    initFilterAccordion();
    initPriceSlider();
    initSortSelect();
    initLoadMore();
    initPillsState();
    updateMobileFilterBadge();
    if (w.ESCollES && typeof w.ESCollES.reinit === 'function') w.ESCollES.reinit();
    if (w.EroticWishlist && typeof w.EroticWishlist.sync === 'function') w.EroticWishlist.sync();
  }

  /* ──────────────────────────────────────────────────────
     INIT
  ────────────────────────────────────────────────────── */
  d.addEventListener('DOMContentLoaded', function () {
    initFilterAccordion();
    initPriceSlider();
    initMobileSheet();        /* delegation — bir kez */
    initSortSelect();
    initLoadMore();
    initPillsState();
    initPillsAjax();          /* delegation — bir kez */
    initFilterAjax();         /* delegation — bir kez (marka/renk/stok/chip → AJAX) */
    initStockClearTracking(); /* delegation — bir kez */
    updateMobileFilterBadge();
  });

  /* ──────────────────────────────────────────────────────
     PUBLIC API
  ────────────────────────────────────────────────────── */
  w.ESColl = {
    reinit:               reinitModules,
    navigateToCollection: navigateToCollection
  };

}(window, document));

/* es_stok_cleared / __esStokCleared mekanizması KALDIRILDI —
   default stok filtresi redirect'i silindiğinde tüketicisi kalmadı. */